import Selections from './_selections.json';

export default Selections;



// WEBPACK FOOTER //
// ./src/components/Icomoon/tbk-Portal-Icons.js